@if (pagination) {
  <mat-paginator
    [ngClass]="options && options.paginatorClass"
    [hidePageSize]="options && options.hidePageSize"
    [showFirstLastButtons]="showFirstLastButtons"
    [length]="pagination.totalItems"
    [pageSize]="pagination.size"
    [pageIndex]="pagination.page - pageIndexOffset"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onMatPagechange($event)"
  >
  </mat-paginator>
}
